module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xtzb-box"
  }, [(_vm.localData.isOpenHelp == 1) ? _c('div', {
    staticClass: "xtzb-list"
  }, [(_vm.mainScreenUser && _vm.isHost) ? _c('div', {
    staticClass: "xtzb-zhubo"
  }, [_c('xietongzhubo', {
    attrs: {
      "main-screen-data": _vm.mainScreenUser,
      "liveId": _vm.liveId
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isHost && _vm.isJoinedHelpLive && _vm.isSelfMainScreen && _vm.hostUser) ? _c('div', {
    staticClass: "xtzb-zhubo"
  }, [_c('zhuboplayer', {
    attrs: {
      "pull-url": _vm.hostUser.pullUrl,
      "user-info": _vm.hostUser.info
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(((_vm.isHost ? _vm.localData.helpLiveUserList : _vm.helpLiveUserList)), function(item, index) {
    return (item.isMainScreen !== 1) ? _c('div', {
      key: index,
      staticClass: "xtzb-item",
      class: {
        'xtzb-item-active': _vm.activeIndex === index
      }
    }, [_c('div', {
      staticClass: "xtzb-item-bg",
      style: ({
        backgroundImage: 'url(' + (item.userInfo && item.userInfo.headPortrait) + ')'
      })
    }), _vm._v(" "), (item.cameraStatus !== 0) ? [(_vm.isSelfCohost(item)) ? _c('div', {
      staticClass: "xtzb-item-video xtzb-item-pusher",
      staticStyle: {
        "position": "absolute",
        "top": "0",
        "left": "0",
        "width": "100%",
        "height": "100%",
        "z-index": "2",
        "overflow": "hidden"
      },
      attrs: {
        "id": 'pusher-' + item.userId
      }
    }) : _c('div', {
      staticClass: "xtzb-item-player",
      attrs: {
        "id": 'player-' + item.userId
      }
    })] : _vm._e(), _vm._v(" "), (item.cameraStatus === 0) ? _c('div', {
      staticClass: "xtzb-item-cover"
    }, [_c('div', {
      staticClass: "xtzb-item-cover-box"
    }, [_c('img', {
      staticClass: "xtzb-item-cover-img",
      attrs: {
        "src": item.userInfo && item.userInfo.headPortrait,
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (item.isPermitMicrophone == 1) ? _c('img', {
      staticClass: "xtzb-item-vioce",
      attrs: {
        "src": require("../../assets/image/zbj_lb_jy_2@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMicrophone(item, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.isPermitMicrophone == 0) ? _c('img', {
      staticClass: "xtzb-item-vioce",
      attrs: {
        "src": require("../../assets/image/zbj_lb_jy_3@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleMicrophone(item, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "xtzb-item-user"
    }, [_c('span', {
      staticClass: "xtzb-item-user-sort"
    }, [_vm._v(_vm._s((_vm.mainScreenUser && _vm.isHost) || (!_vm.isHost && _vm.isJoinedHelpLive && _vm.isSelfMainScreen && _vm.hostUser) ? index + 2 : index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-item-user-name"
    }, [_vm._v(_vm._s(item.userInfo.nickName))])])], 2) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.localData.isOpenHelp == 1 && _vm.isHost) ? _c('div', {
    staticClass: "xtzb-btn",
    on: {
      "click": _vm.handleOpenList
    }
  }, [_c('span', {
    staticClass: "xtzb-btn-text"
  }, [_vm._v(_vm._s(_vm.$t('all.xietongzhibo')) + " " + _vm._s(_vm.localData ? _vm.localData.helpLiveUserList.length : 0) + "/" + _vm._s(_vm.localData ? _vm.localData.peopleNumber : 0))])]) : _vm._e(), _vm._v(" "), (_vm.showPanel) ? _c('div', {
    staticClass: "xtzb-panel-overlay",
    on: {
      "click": function($event) {
        _vm.showPanel = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPanel) ? _c('div', {
    staticClass: "xtzb-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-panel-header"
  }, [_c('span', {
    staticClass: "xtzb-panel-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xietongzhibo')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-panel-count"
  }, [_vm._v(_vm._s(_vm.localData ? _vm.localData.helpLiveUserList.length : 0) + "/" + _vm._s(_vm.localData ? _vm.localData.peopleNumber : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-panel-users"
  }, [(_vm.localData.helpLiveUserList && _vm.localData.helpLiveUserList.length > 0) ? _vm._l((_vm.localData.helpLiveUserList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xtzb-panel-user",
      class: {
        'xtzb-panel-user-active': _vm.activeIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.handleSelect(index)
        }
      }
    }, [_c('img', {
      staticClass: "xtzb-panel-user-img",
      attrs: {
        "src": item.userInfo.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "xtzb-panel-user-name"
    }, [_vm._v(_vm._s(item.userInfo.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-panel-user-status",
      class: item.isPermitCamera === 1 ? 'xtzb-status-live' : (item.isPermitMicrophone === 1 ? 'xtzb-status-live' : 'xtzb-status-wait')
    }, [_vm._v("\n              " + _vm._s(item.isPermitCamera === 1 ? _vm.$t('all.shipin') : (item.isPermitMicrophone === 1 ? _vm.$t('all.kaimai') : _vm.$t('all.weikaiqi'))) + "\n            ")])])
  }) : _c('div', {
    staticClass: "xtzb-panel-empty"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('all.zanwushuju')) + "\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "xtzb-panel-actions"
  }, [_c('div', {
    staticClass: "xtzb-panel-action-btn",
    on: {
      "click": _vm.handleInvite
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yaoqingjinbo')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-panel-action-btn",
    on: {
      "click": _vm.handleControl
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tongyikongmai')))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-panel-kick-btn",
    on: {
      "click": _vm.handleKick
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tichuzhubozb')))])]) : _vm._e(), _vm._v(" "), (_vm.showInvite) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showInvite = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showInvite) ? _c('div', {
    staticClass: "xtzb-invite-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-invite-title"
  }, [_vm._v(_vm._s(_vm.$t('all.yaoqingjinbo')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item",
    on: {
      "click": _vm.handleOpenLimit
    }
  }, [_c('span', {
    staticClass: "xtzb-invite-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuborenshushangxian')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item-right"
  }, [_c('span', {
    staticClass: "xtzb-invite-item-value"
  }, [_vm._v(_vm._s(_vm.maxCohost) + _vm._s(_vm.$t('all.ren')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item"
  }, [_c('span', {
    staticClass: "xtzb-invite-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.keyongshiduan')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item-right"
  }, [_c('span', {
    staticClass: "xtzb-invite-item-value"
  }, [_vm._v(_vm._s(_vm.$t('all.tongzhibojinyao')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-section-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuboquanxian')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item",
    on: {
      "click": function($event) {
        _vm.zbForm.isPermitSpeech = _vm.zbForm.isPermitSpeech === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-invite-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxufayan')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item-right"
  }, [_c('span', {
    class: _vm.zbForm.isPermitSpeech === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.zbForm.isPermitSpeech === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item",
    on: {
      "click": function($event) {
        _vm.zbForm.isPermitMicrophone = _vm.zbForm.isPermitMicrophone === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-invite-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxukamai')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item-right"
  }, [_c('span', {
    class: _vm.zbForm.isPermitMicrophone === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.zbForm.isPermitMicrophone === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item",
    on: {
      "click": function($event) {
        _vm.zbForm.isPermitCamera = _vm.zbForm.isPermitCamera === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-invite-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxukashipin')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-item-right"
  }, [_c('span', {
    class: _vm.zbForm.isPermitCamera === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.zbForm.isPermitCamera === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-invite-btn",
    on: {
      "click": _vm.handleGenerateKey
    }
  }, [_vm._v(_vm._s(_vm.$t('all.shengchengyaoqingjinyao')))]), _vm._v(" "), (_vm.showLimitPanel) ? _c('div', {
    staticClass: "xtzb-limit-panel"
  }, [_c('div', {
    staticClass: "xtzb-limit-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xietongzhiborenshu')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-limit-options"
  }, _vm._l((_vm.limitOptions), function(item) {
    return _c('div', {
      key: item,
      class: _vm.tempMaxCohost === item ? 'xtzb-limit-option-active' : 'xtzb-limit-option',
      on: {
        "click": function($event) {
          _vm.tempMaxCohost = item
        }
      }
    }, [_vm._v(_vm._s(item) + _vm._s(_vm.$t('all.ren')))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "xtzb-limit-info"
  }, [_c('div', {
    staticClass: "xtzb-limit-info-title"
  }, [_vm._v(_vm._s(_vm.$t('all.dangqianzhibo')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-limit-info-num"
  }, [_c('span', {
    staticClass: "xtzb-limit-info-big"
  }, [_vm._v("0")]), _vm._v("/" + _vm._s(_vm.tempMaxCohost))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-limit-info-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.kenenghaiyaoqing')) + " " + _vm._s(_vm.tempMaxCohost) + " " + _vm._s(_vm.$t('all.weizhibo')))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-limit-save",
    on: {
      "click": _vm.handleSaveLimit
    }
  }, [_vm._v(_vm._s(_vm.$t('all.baocunshangxian')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showShareInvite) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showShareInvite = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShareInvite) ? _c('div', {
    staticClass: "xtzb-share-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-share-title"
  }, [_vm._v(_vm._s(_vm.$t('all.fenxiangyaoqing')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-qrcode"
  }, [_c('canvas', {
    ref: "qrcodeCanvas"
  })]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-item"
  }, [_c('span', {
    staticClass: "xtzb-share-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yaoqinglianjie')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-share-item-value"
  }, [_vm._v(_vm._s(_vm.liveConfig.shareUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-item"
  }, [_c('span', {
    staticClass: "xtzb-share-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojinyao')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-share-item-value"
  }, [_vm._v(_vm._s(_vm.liveConfig.startKey))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('all.fenxiangfangshi')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-actions"
  }, [_c('div', {
    staticClass: "xtzb-share-action-btn xtzb-share-action-gradient",
    on: {
      "click": _vm.handleCopyLink
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhilianjie')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-share-action-btn",
    on: {
      "click": _vm.handleSaveQr
    }
  }, [_vm._v(_vm._s(_vm.$t('all.baocunerweima')))])])]) : _vm._e(), _vm._v(" "), (_vm.showControlModal) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showControlModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showControlModal) ? _c('div', {
    staticClass: "xtzb-control-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-control-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tongyikongmai')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-section"
  }, [_vm._v(_vm._s(_vm.$t('all.quanjukongzhi')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item",
    on: {
      "click": function($event) {
        _vm.controlForm.isPermitSpeech = _vm.controlForm.isPermitSpeech === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-control-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxufayan')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item-right"
  }, [_c('span', {
    class: _vm.controlForm.isPermitSpeech === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.controlForm.isPermitSpeech === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item",
    on: {
      "click": function($event) {
        _vm.controlForm.isPermitMicrophone = _vm.controlForm.isPermitMicrophone === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-control-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxuzhubokaimai')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item-right"
  }, [_c('span', {
    class: _vm.controlForm.isPermitMicrophone === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.controlForm.isPermitMicrophone === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item",
    on: {
      "click": function($event) {
        _vm.controlForm.isPermitCamera = _vm.controlForm.isPermitCamera === 1 ? 0 : 1
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-control-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxuzhubokaishipin')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-item-right"
  }, [_c('span', {
    class: _vm.controlForm.isPermitCamera === 1 ? 'xtzb-control-status-on' : 'xtzb-control-status-off'
  }, [_vm._v(_vm._s(_vm.controlForm.isPermitCamera === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-control-apply",
    on: {
      "click": _vm.handleApplyControl
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yingyongshezhi')))])]) : _vm._e(), _vm._v(" "), (_vm.showCohostList) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showCohostList = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCohostList) ? _c('div', {
    staticClass: "xtzb-cohost-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-cohost-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhubo')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-cohost-list"
  }, _vm._l((_vm.helpUserList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xtzb-cohost-item"
    }, [_c('img', {
      staticClass: "xtzb-cohost-item-avatar",
      attrs: {
        "src": item.userInfo.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "xtzb-cohost-item-info"
    }, [_c('span', {
      staticClass: "xtzb-cohost-item-name"
    }, [_vm._v(_vm._s(item.userInfo.nickName))]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-cohost-item-box"
    }, [_c('span', {
      staticClass: "xtzb-cohost-item-status",
      class: item.isPermitCamera === 1 ? 'xtzb-cohost-status-live' : 'xtzb-cohost-status-wait'
    }, [_vm._v("\n\t\t\t\t  " + _vm._s(item.isPermitCamera === 1 ? _vm.$t('all.shipinkaiqi') : _vm.$t('all.shipinguanbi')) + "\n\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-cohost-item-status xtzb-cohost-status-live"
    }, [_vm._v("/")]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-cohost-item-status",
      class: item.isPermitMicrophone === 1 ? 'xtzb-cohost-status-live' : 'xtzb-cohost-status-wait'
    }, [_vm._v("\n\t\t\t\t  " + _vm._s(item.isPermitMicrophone === 1 ? _vm.$t('all.kaimai') : _vm.$t('all.bimai')) + "\n\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-cohost-item-status xtzb-cohost-status-live"
    }, [_vm._v("/")]), _vm._v(" "), _c('span', {
      staticClass: "xtzb-cohost-item-status",
      class: item.isPermitSpeech === 1 ? 'xtzb-cohost-status-live' : 'xtzb-cohost-status-wait'
    }, [_vm._v("\n\t\t\t\t  " + _vm._s(item.isPermitSpeech === 1 ? _vm.$t('all.yunxufayan') : _vm.$t('all.jinzhifayan')) + "\n\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "xtzb-cohost-item-manage",
      on: {
        "click": function($event) {
          return _vm.handleManageCohost(item, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.guanli')))])])
  }), 0), _vm._v(" "), (_vm.showManagePanel) ? _c('div', {
    staticClass: "xtzb-manage-panel"
  }, [_c('div', {
    staticClass: "xtzb-manage-close",
    on: {
      "click": function($event) {
        _vm.showManagePanel = false
      }
    }
  }, [_vm._v("✕")]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-user"
  }, [_c('img', {
    staticClass: "xtzb-manage-user-avatar",
    attrs: {
      "src": _vm.managingCohost.userInfo.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-user-info"
  }, [_c('span', {
    staticClass: "xtzb-manage-user-name"
  }, [_vm._v(_vm._s(_vm.managingCohost.userInfo.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-manage-user-id"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuboxiwei')) + " " + _vm._s(_vm.activeIndex + 1))])]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-manage-user-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.yijinru')))])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-section-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuboquanxian')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-item",
    on: {
      "click": function($event) {
        return _vm.handleUpdatePerm('isPermitSpeech')
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-label"
  }, [_vm._v(_vm._s(_vm.$t('all.yunxufayan')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-right"
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-status",
    class: {
      'xtzb-manage-perm-status-on': _vm.managingCohost.isPermitSpeech === 1
    }
  }, [_vm._v(_vm._s(_vm.managingCohost.isPermitSpeech === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-item",
    on: {
      "click": function($event) {
        return _vm.handleUpdatePerm('isPermitMicrophone')
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-label"
  }, [_vm._v(_vm._s(_vm.$t('all.maikefeng')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-right"
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-status",
    class: {
      'xtzb-manage-perm-status-on': _vm.managingCohost.isPermitMicrophone === 1
    }
  }, [_vm._v(_vm._s(_vm.managingCohost.isPermitMicrophone === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-item",
    on: {
      "click": function($event) {
        return _vm.handleUpdatePerm('isPermitCamera')
      }
    }
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shexiangtou')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-perm-right"
  }, [_c('span', {
    staticClass: "xtzb-manage-perm-status",
    class: {
      'xtzb-manage-perm-status-on': _vm.managingCohost.isPermitCamera === 1
    }
  }, [_vm._v(_vm._s(_vm.managingCohost.isPermitCamera === 1 ? _vm.$t('all.yikaiqi') : _vm.$t('all.guanbi')))]), _vm._v(" "), _c('img', {
    staticClass: "xtzb-invite-item-arrow",
    attrs: {
      "src": require("../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-btn",
    on: {
      "click": _vm.handleSetMain
    }
  }, [_vm._v(_vm._s(_vm.managingCohost.isMainScreen === 1 ? _vm.$t('all.quxiaozhuyemian') : _vm.$t('all.sheweizhuyemian')))]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-manage-kick-btn",
    on: {
      "click": _vm.handleKickCohost
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tichuzhibo')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-manage-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.tichuhoubukejinru')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showJoinLive) ? _c('div', {
    staticClass: "xtzb-invite-overlay",
    on: {
      "click": function($event) {
        _vm.showJoinLive = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showJoinLive) ? _c('div', {
    staticClass: "xtzb-join-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xtzb-join-title"
  }, [_vm._v(_vm._s(_vm.$t('all.jiaruxietongzhibo')))]), _vm._v(" "), (_vm.helpKey) ? _c('div', {
    staticClass: "xtzb-join-item"
  }, [_c('span', {
    staticClass: "xtzb-join-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhubo')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-join-item-value"
  }, [_vm._v(_vm._s(_vm.helpKeyInfo ? _vm.helpKeyInfo.liveName : ''))])]) : _vm._e(), _vm._v(" "), (_vm.helpKey) ? _c('div', {
    staticClass: "xtzb-join-item"
  }, [_c('span', {
    staticClass: "xtzb-join-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.youxiaoqi')))]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-join-item-value"
  }, [_vm._v(_vm._s(_vm.helpKeyInfo ? _vm.helpKeyInfo.keyStartTime + '-' + _vm.helpKeyInfo.keyEndTime : ''))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "xtzb-join-item"
  }, [_c('span', {
    staticClass: "xtzb-join-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhubojinyao')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helpKeyInfo.helpKey),
      expression: "helpKeyInfo.helpKey"
    }],
    staticClass: "xtzb-join-input",
    attrs: {
      "placeholder": _vm.$t('all.qingshuruzhubojinyao')
    },
    domProps: {
      "value": (_vm.helpKeyInfo.helpKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helpKeyInfo, "helpKey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xtzb-join-btn",
    on: {
      "click": _vm.handleSubmitJoin
    }
  }, [_vm._v(_vm._s(_vm.$t('all.jiaru')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2986d701"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xietongzhibo/xietongzhibo.vue
// module id = 964
// module chunks = 1